import { fromJS, List } from 'immutable';
import { handleActions } from 'redux-actions';
import { SET_EVENTS_DATA } from '../socket/constants';
import {
  MUTE_EVENTS,
  APPEND_EVENT_SUCCESS,
  FETCH_EVENTS_SUCCESS,
  FETCH_EVENTS_FAILURE,
  SET_CURRENT_EVENT,
  UNSET_CURRENT_EVENT
} from './constants';

const LIST_LIMIT = 200;
const initialState = fromJS({
  'error': null,
  'items': [],
  'currentEvent': null,
  'loading': false,
  'audioIsMuted': true,
});

export default handleActions({
  [APPEND_EVENT_SUCCESS]: (state: any, { payload }: any ) => {
    if (!payload.hasOwnProperty('id')) return state;

    return state.update('items', (items: List<any>) => {
      const item = items.find((i: any) => i.get('id') === payload.id);

      if (!item) return items.insert(0, fromJS(payload))

      return items;
    })
  },
  [SET_CURRENT_EVENT]: (state: any, { payload }: any) => {
    return state.set('currentEvent', fromJS(payload))
  },
  [UNSET_CURRENT_EVENT]: (state: any, { payload }: any) => {
    return state.set('currentEvent', null)
  },
  [FETCH_EVENTS_SUCCESS]: (state: any, { payload }: any) => {
    return state.set('items', fromJS(payload))
  },
  [FETCH_EVENTS_FAILURE]: (state: any, { payload }: any) => {
    return state.set('error', payload)
  },
  [MUTE_EVENTS]: (state: any, { payload }: any) => {
    return state.set('audioIsMuted', payload);
  },
  [SET_EVENTS_DATA]: (state: any, { payload }: any) => {
    return state.unshift(payload.data).slice(0, LIST_LIMIT);
  },
}, initialState);
